import React from 'react';
import { Header } from './components/Header';
import { AdvertorialContent } from './components/AdvertorialContent';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap" rel="stylesheet" data-id="element-1" />
      <Header data-id="element-2" />
      <AdvertorialContent data-id="element-3" />
      <Footer data-id="element-4" />
    </div>;
}